import { registerBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import './style.scss';
import Edit from './edit';
import metadata from './block.json';
import { RxLoop } from "react-icons/rx";
import Save from './save';
import advancejson from '@vayu-blocks/advance-panel/advance.json';
const { name } = metadata;

registerBlockType('vayu-blocks/advance-query-loop', {
     attributes: {
            ...metadata.attributes, // Keep existing attributes from block.json
            ...advancejson, // Add attributes from advanceSettings.json
        },
	icon: <RxLoop style={{color:'#6c1bc3',fontSize:'12px'}} />,
    edit: Edit,
    save: Save,
});